import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  getCountries:      config => axios.get(`${apiUrl}/dictionary/countries`, config),
  getRegions:        config => axios.get(`${apiUrl}/dictionary/regions`, config),
  getCountryPresets: config => axios.get(`${apiUrl}/dictionary/country-presets`, config),
};
